import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { BaseChartModel } from "@/Patient/Models/GrowthCharts/BaseChartModel";
import { ChartDataPointBase } from "@/Patient/Models/GrowthCharts/ChartData";

interface PatientChartDataTableProps {
    chart: BaseChartModel;
    hightlightRow?: ChartDataPointBase;
    onVitalSignClick: (medicalItemId: string) => void;
}

abstract class PatientChartTable<TProps extends PatientChartDataTableProps, TState> extends BaseReactComponent<TProps, TState> {
    protected tableContainer: HTMLElement;
    protected tableRows: { [name: string]: HTMLElement } = {};

    protected abstract renderTableBody(): JSX.Element;
    protected abstract renderTableHeader(): JSX.Element;

    protected renderTable(): JSX.Element {
        return (
            <table data-cy={`growthCharts-datatable-${this.props.chart.id}`}>
                {this.renderTableHeader()}
                {this.renderTableBody()}
            </table>
        );
    }

    protected getRowClass(rowId: string): string {
        if (rowId === this.props.hightlightRow?.id) {
            this.tableContainer.scroll(0, this.tableRows[rowId].offsetTop - (this.tableRows[rowId].offsetWidth / 2));

            return "active";
        }

        return "";
    }
}

export { PatientChartDataTableProps, PatientChartTable };
